"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = _interopRequireDefault(require("@trs/config"));
var _StatusPill = _interopRequireDefault(require("./StatusPill.style"));
var _excluded = ["id", "name", "size", "status", "showCircle", "value"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var REWARD_STATUSES = _config["default"].REWARD_STATUSES,
  GENERAL_STATUSES_KEYS = _config["default"].GENERAL_STATUSES_KEYS;
var StatusPill = function StatusPill(_ref) {
  var id = _ref.id,
    name = _ref.name,
    size = _ref.size,
    status = _ref.status,
    showCircle = _ref.showCircle,
    value = _ref.value,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_StatusPill["default"], _extends({
    id: id,
    name: name,
    status: status,
    size: size,
    value: value
  }, otherProps), name && /*#__PURE__*/_react["default"].createElement("span", {
    className: "pill-name"
  }, name, ":"), showCircle && /*#__PURE__*/_react["default"].createElement("span", {
    className: "pill-circle"
  }), value && /*#__PURE__*/_react["default"].createElement("span", {
    className: "pill-value"
  }, value));
};
StatusPill.propTypes = {
  showCircle: _propTypes["default"].bool,
  /**
   * Html id for the element
   */
  id: _propTypes["default"].string,
  /**
   * The label for this element
   */
  name: _propTypes["default"].string,
  /**
   * The text size of the elements
   */
  size: _propTypes["default"].number,
  /**
   * The status one of: 'draft', 'expired', 'live', 'published'
   * 'status_draft', 'status_published', 'status_live', 'status_expired', 'status_error
   */
  status: _propTypes["default"].oneOf([].concat(_toConsumableArray(R.keys(REWARD_STATUSES)), _toConsumableArray(R.keys(GENERAL_STATUSES_KEYS)))).isRequired,
  /**
   * The status value (text)
   */
  value: _propTypes["default"].string
};
StatusPill.defaultProps = {
  showCircle: true,
  name: undefined,
  size: 12,
  id: '',
  value: ''
};
var _default = exports["default"] = StatusPill;